var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay215X64(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135 40",
    width: 215,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.8,
    y1: 173.29,
    x2: 5.02,
    y2: 156.51,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 33.83,
    y1: 162,
    x2: 9.64,
    y2: 162,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 24.83,
    y1: 159.7,
    x2: 2.07,
    y2: 136.95,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 7.3,
    y1: 181.82,
    x2: 17.46,
    y2: 171.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130,.8A4.2,4.2,0,0,1,134.2,5V35a4.2,4.2,0,0,1-4.2,4.2H5A4.2,4.2,0,0,1,.8,35V5A4.2,4.2,0,0,1,5,.8H130m0-.8H5A5,5,0,0,0,0,5V35a5,5,0,0,0,5,5H130a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.42,10.24a2.71,2.71,0,0,1-.75,2,2.91,2.91,0,0,1-2.2.89A3.09,3.09,0,0,1,41.35,10a3.09,3.09,0,0,1,3.12-3.13,3.1,3.1,0,0,1,1.23.25,2.47,2.47,0,0,1,.94.67l-.53.53a2,2,0,0,0-1.64-.71A2.32,2.32,0,0,0,42.14,10a2.36,2.36,0,0,0,4,1.73,1.89,1.89,0,0,0,.5-1.22H44.47V9.79h2.91A2.54,2.54,0,0,1,47.42,10.24Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,7.74H49.3v1.9h2.46v.72H49.3v1.9H52V13h-3.5V7H52Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.28,13h-.77V7.74H52.83V7H57v.74H55.28Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.94,13V7h.77v6Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,13h-.77V7.74H61.68V7H65.8v.74H64.13Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.61,12.22a3.12,3.12,0,0,1-4.4,0A3.07,3.07,0,0,1,68.33,10a3.07,3.07,0,0,1,.88-2.22,3.1,3.1,0,0,1,4.4,0A3.07,3.07,0,0,1,74.49,10,3.07,3.07,0,0,1,73.61,12.22Zm-3.83-.5a2.31,2.31,0,0,0,3.26,0A2.35,2.35,0,0,0,73.71,10,2.35,2.35,0,0,0,73,8.28a2.31,2.31,0,0,0-3.26,0A2.35,2.35,0,0,0,69.11,10,2.35,2.35,0,0,0,69.78,11.72Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.58,13V7h.94l2.92,4.67h0l0-1.16V7h.77v6h-.8L76.35,8.11h0l0,1.16V13Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.14,21.75A4.25,4.25,0,1,0,72.41,26,4.19,4.19,0,0,0,68.14,21.75Zm0,6.83A2.58,2.58,0,1,1,70.54,26,2.46,2.46,0,0,1,68.14,28.58Zm-9.31-6.83A4.25,4.25,0,1,0,63.09,26,4.19,4.19,0,0,0,58.82,21.75Zm0,6.83A2.58,2.58,0,1,1,61.22,26,2.46,2.46,0,0,1,58.82,28.58ZM47.74,23.06v1.8h4.32a3.76,3.76,0,0,1-1,2.27,4.42,4.42,0,0,1-3.33,1.32,4.8,4.8,0,0,1,0-9.6A4.6,4.6,0,0,1,51,20.14l1.27-1.27A6.3,6.3,0,0,0,47.74,17a6.61,6.61,0,1,0,0,13.21,6,6,0,0,0,4.61-1.85,6,6,0,0,0,1.56-4.22,5.89,5.89,0,0,0-.1-1.13Zm45.31,1.4a4,4,0,0,0-3.64-2.71,4,4,0,0,0-4,4.25,4.16,4.16,0,0,0,4.22,4.25,4.23,4.23,0,0,0,3.54-1.88l-1.45-1a2.43,2.43,0,0,1-2.09,1.18,2.16,2.16,0,0,1-2.06-1.29l5.69-2.35Zm-5.8,1.42a2.33,2.33,0,0,1,2.22-2.48,1.65,1.65,0,0,1,1.58.9ZM82.63,30H84.5V17.5H82.63Zm-3.06-7.3H79.5a3,3,0,0,0-2.24-1,4.26,4.26,0,0,0,0,8.51,2.9,2.9,0,0,0,2.24-1h.06v.61c0,1.63-.87,2.5-2.27,2.5a2.35,2.35,0,0,1-2.14-1.51l-1.63.68a4.05,4.05,0,0,0,3.77,2.51c2.19,0,4-1.29,4-4.43V22H79.57Zm-2.14,5.88a2.59,2.59,0,0,1,0-5.16A2.4,2.4,0,0,1,79.7,26,2.38,2.38,0,0,1,77.42,28.58ZM101.81,17.5H97.34V30H99.2V25.26h2.61a3.89,3.89,0,1,0,0-7.77Zm0,6H99.2V19.24h2.65a2.14,2.14,0,1,1,0,4.29Zm11.53-1.8a3.5,3.5,0,0,0-3.33,1.91l1.66.69a1.77,1.77,0,0,1,1.71-.92,1.8,1.8,0,0,1,2,1.61v.13a4.13,4.13,0,0,0-1.95-.48c-1.79,0-3.6,1-3.6,2.81a2.89,2.89,0,0,0,3.1,2.75A2.63,2.63,0,0,0,115.32,29h.06v1h1.8V25.19C117.18,23,115.52,21.73,113.39,21.73Zm-.23,6.85c-.61,0-1.46-.31-1.46-1.06,0-1,1.06-1.34,2-1.34a3.32,3.32,0,0,1,1.7.42A2.26,2.26,0,0,1,113.16,28.58ZM123.74,22l-2.14,5.42h-.06L119.32,22h-2l3.33,7.58-1.9,4.21h1.95L125.82,22Zm-16.81,8h1.87V17.5h-1.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44,7.54A2,2,0,0,0,10,8.94V31.06a2,2,0,0,0,.46,1.4l.07.07L22.9,20.15v-.29L10.51,7.47Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,24.28,22.9,20.15v-.29L27,15.72l.09.05L32,18.56c1.4.79,1.4,2.09,0,2.89l-4.89,2.78Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12,24.23,22.9,20,10.44,32.46a1.63,1.63,0,0,0,2.08.06l14.61-8.3",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12,15.78,12.51,7.48a1.63,1.63,0,0,0-2.08.06L22.9,20Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,24.13,12.51,32.38a1.67,1.67,0,0,1-2,0h0l-.07.07h0l.07.07h0a1.67,1.67,0,0,0,2,0l14.61-8.3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44,32.32a2,2,0,0,1-.46-1.4v.15a2,2,0,0,0,.46,1.4l.07-.07Z",
    style: {
      opacity: 0.12,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,21.3l-5,2.83.09.09L32,21.44a1.75,1.75,0,0,0,1-1.44h0A1.86,1.86,0,0,1,32,21.3Z",
    style: {
      opacity: 0.12,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.51,7.62,32,18.7a1.86,1.86,0,0,1,1,1.3h0a1.75,1.75,0,0,0-1-1.44L12.51,7.48C11.12,6.68,10,7.34,10,8.94v.15C10,7.49,11.12,6.83,12.51,7.62Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      isolation: "isolate"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay215X64);
export default __webpack_public_path__ + "static/media/google-play_215x64.1735e12f9687d5f48663f351ea8dd504.svg";
export { ForwardRef as ReactComponent };